/**
 * Shared product contracts — consumed by both the Express BFF and the React frontend.
 *
 * `ProductType` is the canonical enum for product categories.
 * `AppProduct`  is the normalised product shape the BFF serialises and the frontend consumes.
 * The raw Shopify GraphQL product shape (with variants/edges) stays server-side only.
 */

export const ProductType = {
    SOLAR_PANEL: "Solar Panel",
    INVERTER: "Wechselrichter",
    BATTERY_STORAGE: "Battery",
    ACCESSORY: "Accessory",
    MOUNTING_SYSTEM: "Mounting System",
    SERVICE_PACKAGE: "Service Package",
    OTHERS: "others",
} as const;

export type ProductType = (typeof ProductType)[keyof typeof ProductType];

export const AvailableGoal = {
    BASIC: "basic",
    ADVANCED: "advanced",
    HIGHEND: "highend",
} as const;

export type AvailableGoal = (typeof AvailableGoal)[keyof typeof AvailableGoal];

export interface ProductScalingRule {
    minPeak: number;
    maxPeak: number;
    price: number;
}

export interface ProductScalingRules {
    scalingRules?: ProductScalingRule[];
}

/**
 * Normalised product that the BFF builds from raw Shopify data and sends to the frontend.
 * Rename from the legacy `Product` (server) / `ShopifyProduct` (frontend) — they were the same shape.
 */
export interface AppProduct {
    id: string|number;
    name: string;
    description: string;
    price: number;
    type: ProductType;
    merchandiseId?: string;
    bundleId?: string;
    guarantee?: string;
    mainFieldOne?: string;
    mainFieldTwo?: string;
    manufacturer?: string;
    moduleType?: string;
    surchargePercentage?: number;
    powerClass?: number;
    scalingRules?: ProductScalingRules;
    area?: number;
    efficiencyFactor?: number;
    tags?: string[];
    properties?: string[];
}
